import { render, staticRenderFns } from "./AttitudesAwardView.vue?vue&type=template&id=e200d0e0&scoped=true&"
import script from "./AttitudesAwardView.vue?vue&type=script&lang=js&"
export * from "./AttitudesAwardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e200d0e0",
  null
  
)

export default component.exports